import {
  Dropdown,
  DropdownButton,
  DropdownItem,
  DropdownMenu,
  Option,
  Select,
} from "@deere/fuel-react";
import {
  Box,
  Button,
  CircularProgress, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle,
  Grid,
  Typography,
} from "@mui/material";
import { ReportProblemRounded } from "@mui/icons-material";
import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import "../../App.css";
import {
  deleteAttachments,
  deleteTransactionResponse,
  postTransactionAttachmentsDetails,
  postTransactionDetails,
  putTransactionDetails,
} from "../../api/api";
import {
  CASH_SALE,
  CONFIRM_SUBMITTED_TRANSACTION,
  DELETE_TRANSACTION,
  LEASE,
  RETAIL_NOTE,
  SALES_MANAGER_ROLE,
  SUBMIT_TRANSACTION,
  TXN_SCOPE,
  TXN_STATUS,
  accordion,
} from "../../utilities/constants.js";
import {
  bidResultValidator,
  onSubmitHandler,
  onSubmitWarningAlert,
} from "../../utilities/tp-validations";
import { isAuthorizedactivity } from "../Utility/isAuthorizedactivity";
import ToastUtility from "../Utility/toast-utility";
import ConnectedTransactionAttachmentModal from "./connected-transaction-attachment-modal.js";

function TransactionUtilityBar(props) {
  const history = useHistory();
  const [flags, setFlags] = useState({
    open: false,
    deleteActionClick: false,
    showToast: "none",
    confirmBtnClick: false,
    deleteBtnClick: false,
    warningAlerts: [],
    filesToBeDeleted: null,
  });
  const [deleteAttachResp, setDeleteAttachResp] = useState({});
  const { action } = props.actionType;
  const authorizedActivities = props.isSimulateMode
      ? props.simulatedBusinessActivities
      : props.businessActivities;

  const handleFormDataAndAttachments = async (data) => {
    history.push("/");
    const formData = new FormData();
    props.transactionAttachments.forEach(
        ({ fileId, fileName, fileStatus, file }) => {
          if (fileStatus === "NEW" && !fileId && fileName && file) {
            formData.append("file", file);
          }
        }
    );
    const txnId = data.transactions[0]?.txnId;
    const userId = props.simulatedUserDetails.userId ? props.simulatedUserDetails.userId : props.userDetails.userId;
    const isFormDataValid = formData.has("file");
    const isAttachments = props.transactionAttachments?.length > 0;
    const isTxnIdValid = txnId && txnId > 0;
    const isUserIdValid = userId && userId !== "";

    if (isFormDataValid && isAttachments && isTxnIdValid && isUserIdValid) {
      const response = await postTransactionAttachmentsDetails(
          formData,
          txnId,
          userId,
          props.isSimulateMode
      );
      if (response && response.length > 0) {
        const attachmentResponse = `Attachments ${response.join(
            ", "
        )} failed to upload for Transaction Id:${txnId} `;
        props.setTransactionAttachmentResponse(attachmentResponse);
      }
    }
    props.clearAllAttachments();
  };

  const handleOnClickSaveTransaction = async (txnAction) => {
    setFlags((prevObj) => ({
      ...prevObj,
      confirmBtnClick: true,
    }));
    props.setTextValue("txnStatus", txnAction);
    const validationReturn = onSubmitHandler(props);
    const bidResult = bidResultValidator(props);
    if (validationReturn.length > 0) {
      props.setOnSubmitDetails(validationReturn, true);
      setFlags((prevObj) => ({
        ...prevObj,
        confirmBtnClick: false,
      }));
      return;
    } else if (!bidResult) {
      setFlags((prevObj) => ({
        ...prevObj,
        showToast: "inline",
        confirmBtnClick: false,
      }));
      return;
    }
    const { warningAlerts, filesToBeDeleted } = onSubmitWarningAlert(props);
    if (warningAlerts && warningAlerts.length > 0) {
      setFlags((prevObj) => ({
        ...prevObj,
        open: true,
        confirmBtnClick: false,
        warningAlerts: warningAlerts,
        filesToBeDeleted: filesToBeDeleted,
      }));
      return;
    }
    const transactionReq = {
      ...props.transactionRequest,
      createdByUser: props.isSimulateMode
          ? props.simulatedUserDetails.userId
          : props.userDetails.userId,
      transactions: [
        {
          ...props.transactions,
          saleReason: props.bids.saleReason,
          txnStatus: txnAction,
        },
      ],
    };
    setFlags((prevObj) => ({
      ...prevObj,
      open: false,
    }));
    props.setOnSubmitDetails(validationReturn, false);
    const data =
        props.actionType.action === TXN_SCOPE.CREATE
            ? await postTransactionDetails(transactionReq, props.isSimulateMode)
            : await putTransactionDetails(
            transactionReq,
            props.isSimulateMode,
            props.transactions.txnId
            );
    props.setCreateTransactionResponseObj(data);
    if (data.returnCondition === 0) {
      await handleFormDataAndAttachments(data);
    } else {
      props.setOnSubmitDetails("", true);
    }
    setFlags((prevObj) => ({
      ...prevObj,
      confirmBtnClick: false,
    }));
  };

  const handleSubmit = async () => {
    setFlags((prevObj) => ({
      ...prevObj,
      confirmBtnClick: true,
    }));
    const validationReturn = onSubmitHandler(props);
    const { action } = props.actionType;
    const {
      transactions,
      bids,
      transactionRequest,
      isSimulateMode,
      simulatedUserDetails,
      userDetails,
    } = props;
    let transactionReq = {
      ...transactionRequest,
      createdByUser: isSimulateMode
          ? simulatedUserDetails.userId
          : userDetails.userId,
      transactions: [
        {
          ...transactions,
          txnStatus: transactions.txnStatus,
          saleReason: bids.saleReason,
        },
      ],
    };

    props.setOnSubmitDetails(validationReturn, false);

    if (action === TXN_SCOPE.CREATE || action === TXN_SCOPE.EDIT) {
      const args = [transactionReq, isSimulateMode];

      if (action === TXN_SCOPE.EDIT) {
        args.push(transactions.txnId);
        const putApiPromise = putTransactionDetails(...args);

        if (flags?.filesToBeDeleted) {
          const fileIds = flags.filesToBeDeleted.map(
              (fileObj) => fileObj.fileId
          );
          const deleteApiPromise = deleteAttachments(
              fileIds,
              transactions.txnId,
              props.isSimulateMode
          );

          deleteApiPromise
              .then((deleteData) => {
                setDeleteAttachResp({
                  toastVariant: "success",
                  toastMessage: props.texts.FILE_UPLD_SUC_MSG,
                });
              })
              .catch((error) => {
                setDeleteAttachResp({
                  toastVariant: "error",
                  toastMessage: props.texts.FILE_UPLD_FAIL_MSG,
                });
              });

          try {
            const responseData = await putApiPromise;

            props.setCreateTransactionResponseObj(responseData);

            if (responseData.returnCondition === 0) {
              await handleFormDataAndAttachments(responseData);
            } else {
              props.setOnSubmitDetails("", true);
              setFlags((prevObj) => ({ ...prevObj, open: false }));
            }
          } catch (error) {
            console.error("Error from update Txn:", error);
          }
        } else {
          try {
            const responseData = await putApiPromise;
            props.setCreateTransactionResponseObj(responseData);
            if (responseData.returnCondition === 0) {
              await handleFormDataAndAttachments(responseData);
            } else {
              props.setOnSubmitDetails("", true);
              setFlags((prevObj) => ({ ...prevObj, open: false }));
            }
          } catch (error) {
            console.error(error);
          }
        }
      } else {
        try {
          const data = await postTransactionDetails(...args);
          props.setCreateTransactionResponseObj(data);

          if (data.returnCondition === 0) {
            await handleFormDataAndAttachments(data);
          } else {
            props.setOnSubmitDetails("", true);
            setFlags((prevObj) => ({ ...prevObj, open: false }));
          }
        } catch (error) {
          console.error(error);
        }
      }

      setFlags((prevObj) => ({
        ...prevObj,
        confirmBtnClick: false,
      }));
    }
  };

  const setVisibleAccordianData = () => {
    const excludedTitles = new Set();
    switch (props.paymentMethod) {
      case "Lease":
        excludedTitles.add(RETAIL_NOTE.title);
        excludedTitles.add(CASH_SALE.title);
        break;
      case "Retail Note":
        excludedTitles.add(LEASE.title);
        excludedTitles.add(CASH_SALE.title);
        break;
      case "Cash Sale":
      default:
        excludedTitles.add(CASH_SALE.title);
        excludedTitles.add(RETAIL_NOTE.title);
        excludedTitles.add(LEASE.title);
        break;
    }
    const optionList = Object.keys(accordion)
        .filter((key) => !excludedTitles.has(accordion[key].title))
        .sort((a, b) => accordion[a].index - accordion[b].index)
        .map((key, index) => (
            <Option key={index} value={accordion[key].title}>
              {props.texts[key]}
            </Option>
        ));
    return optionList;
  };

  const hasRole = (expectedRole) => {
    const userDetails = props.isSimulateMode
        ? props.simulatedUserDetails
        : props.userDetails;
    const authorizedRoles = userDetails?.authorizedRoles;
    return (
        authorizedRoles && Object.values(authorizedRoles).includes(expectedRole)
    );
  };

  const setActionDropDownsData = () => {
    const actionDropDownData = [];
    if (action && (action === TXN_SCOPE.CREATE || action === TXN_SCOPE.EDIT)) {
      actionDropDownData.push(
          <DropdownItem
              disabled={flags.confirmBtnClick}
              onClick={() => handleOnClickSaveTransaction(TXN_STATUS.PENDING)}
          >
            {props.texts.SAVE_TRANS_MSG}
          </DropdownItem>
      );
      if (
          isAuthorizedactivity(
              SUBMIT_TRANSACTION.activityId,
              authorizedActivities
          ) &&
          !hasRole(SALES_MANAGER_ROLE)
      ) {
        actionDropDownData.push(
            <DropdownItem
                disabled={flags.confirmBtnClick}
                onClick={() => handleOnClickSaveTransaction(TXN_STATUS.SUBMITTED)}
            >
              {props.texts.SUBMIT_TRANSACTION}
            </DropdownItem>
        );
      } else if (
          isAuthorizedactivity(
              CONFIRM_SUBMITTED_TRANSACTION.activityId,
              authorizedActivities
          )
      ) {
        actionDropDownData.push(
            <DropdownItem
                disabled={flags.confirmBtnClick}
                onClick={() => handleOnClickSaveTransaction(TXN_STATUS.CONFIRMED)}
            >
              {props.texts.CONFIRM_TRANS}
            </DropdownItem>
        );
      }
    }
    if (
        isAuthorizedactivity(
            DELETE_TRANSACTION.activityId,
            authorizedActivities
        ) && (action === TXN_SCOPE.VIEW && hasRole(SALES_MANAGER_ROLE))
    ) {
      actionDropDownData.push(
          <DropdownItem
              onClick={() => {
                setFlags((prevObj) => ({
                  ...prevObj,
                  open: true,
                  deleteActionClick: true,
                }));
              }}
          >
            {props.texts.DELETE_TRAN_MSG}
          </DropdownItem>
      );
    } else if (
        isAuthorizedactivity(
            DELETE_TRANSACTION.activityId,
            authorizedActivities
        ) &&
        action === TXN_SCOPE.EDIT
    ){
      actionDropDownData.push(
          <DropdownItem
              onClick={() => {
                setFlags((prevObj) => ({
                  ...prevObj,
                  open: true,
                  deleteActionClick: true,
                }));
              }}
          >
            {props.texts.DELETE_TRAN_MSG}
          </DropdownItem>
      );
    }
    return actionDropDownData;
  };

  const handleDeleteBtnOnClick = () => {
    setFlags((prevObj) => ({
      ...prevObj,
      deleteBtnClick: true,
    }));
    deleteTransactionResponse(
        props.transactions.txnId,
        props.isSimulateMode
    ).then((response) => {
      setFlags((prevObj) => ({
        ...prevObj,
        open: false,
        deleteActionClick: false,
        deleteBtnClick: false,
      }));
      if (response.txnStatus === "DELETED") {
        props.setCreateTransactionResponseObj(response);
        history.push("/");
      }
    });
  };

  const stickyNavBar = () => {
    const navBar = document.getElementById("TxnNavBar");
    if (navBar) {
      if (window.scrollY > 0) {
        navBar.style.top = "0px";
        navBar.style.position = "fixed";
      } else {
        navBar.style.position = "relative";
      }
    }
  };

  window.addEventListener("scroll", stickyNavBar);
  return (
      <>
        <Box
            id="TxnNavBar"
            bgcolor={"white"}
            sx={{ borderRadius: "4px" }}
            style={{
              zIndex: 10,
              boxShadow: "rgb(240, 240, 240) 0px 2px",
              width: "100%",
            }}
        >
          <Grid alignItems="space-between" container>
            <Grid alignItems="center" item xs={5}>
              <Typography
                  variant="h3"
                  component="h3"
                  style={{
                    color: "black",
                    margin: "10px",
                    textAlign: "left",
                  }}
              >
                {props.texts.TRAN_DATA_ENTRY}
              </Typography>
            </Grid>
            <Grid
                style={{
                  display: "grid",
                  justifyContent: "start",
                  alignItems: "center",
                }}
                item
                xs={5}
            >
              <Select
                  fullWidth={false}
                  id={props.id}
                  value={props.selectedAccordion}
                  onChange={(event) =>
                      props.setSelectedAccordion(event.target.value)
                  }
              >
                {setVisibleAccordianData()}
              </Select>
            </Grid>
            <Grid
                style={{
                  display: "flex",
                  justifyContent: "right",
                  alignItems: "right",
                }}
                item
                xs={action === TXN_SCOPE.VIEW ? 2 : 1}
                pr={1}
            >
              <ConnectedTransactionAttachmentModal />
            </Grid>
            <Grid
                style={{
                  display: setActionDropDownsData()?.length ? "flex" : "none",
                  justifyContent: "right",
                  alignItems: "center",
                }}
                item
                xs={1}
                pr={1}
            >
              <Dropdown>
                <DropdownButton
                    disabled={flags.confirmBtnClick}
                    style={{ backgroundColor: "#FFCC00" }}
                >
                  {props.texts.TP_ACTION}
                </DropdownButton>
                <DropdownMenu align="end">
                  {setActionDropDownsData()}
                </DropdownMenu>
              </Dropdown>
            </Grid>
          </Grid>
        </Box>
        <div>
          <Dialog
              open={flags.open}
              onClose={() =>
                  setFlags((prevObj) => ({
                    ...prevObj,
                    open: false,
                  }))
              }
              aria-labelledby="alert-Modal-title"
              aria-describedby="alert-Modal-description"
          >
            <DialogTitle id="alert-Modal-title">
              <span style={{display: "inline-flex", alignItems: "center"}}>
              <ReportProblemRounded/>
                &nbsp;{`${props.texts.TP_ALERTS}`}
            </span>
            </DialogTitle>
            <DialogContent>
              <ul style={{ margin: "0" }}>
                {flags?.warningAlerts?.map((alert, index) => (
                    <DialogContentText
                        id={`alert-Modal-description-${index}`}
                        variant="h4"
                        style={{ marginBottom: "20px" }}
                    >
                      <li key={index}>{alert}</li>
                    </DialogContentText>
                ))}
              </ul>
            </DialogContent>
            <DialogActions>
              <Button
                  onClick={() =>
                      setFlags((prevObj) => ({
                        ...prevObj,
                        open: false,
                      }))
                  }
                  disabled={flags.confirmBtnClick || flags.deleteBtnClick}
                  variant="secondary"
              >
                {props.texts.CANCEL}
              </Button>
              {flags.deleteActionClick !== true ? (
                  <Button
                      onClick={handleSubmit}
                      variant="primary"
                      disabled={flags.confirmBtnClick}
                      endIcon={
                        flags.confirmBtnClick && (
                            <CircularProgress
                                size="small"
                                style={{ color: "#000", marginLeft: "7px" }}
                            />
                        )
                      }
                  >
                    {props.texts.CNF_SUB_WITH_ALERTS_MSG}
                  </Button>
              ) : (
                  <Button
                      onClick={handleDeleteBtnOnClick}
                      variant="primary"
                      disabled={flags.deleteBtnClick}
                      style={{ color: "white", backgroundColor: "red" }}
                      endIcon={
                        flags.deleteBtnClick && (
                            <CircularProgress
                                size="small"
                                style={{ color: "#000", marginLeft: "7px" }}
                            />
                        )
                      }
                  >
                    {props.texts.DELETE_FUNC}
                  </Button>
              )}
            </DialogActions>
          </Dialog>
        </div>
        <ToastUtility
            toastDisplay={flags.showToast}
            toastVariant="error"
            handleClose={() =>
                setFlags((prevObj) => ({
                  ...prevObj,
                  showToast: "none",
                  confirmBtnClick: false,
                }))
            }
            toastMessage={props.texts.ONE_BID_WON_VALID_MSG}
        />
        {flags.confirmBtnClick && !props.createTransactionResponse && (
            <ToastUtility
                toastDisplay="inline"
                toastVariant="info"
                toastMessage={props.texts.PLZ_WAIT_TXN_MSG}
                handleClose={() =>
                    setFlags((prevObj) => ({
                      ...prevObj,
                      confirmBtnClick: false,
                    }))
                }
            />
        )}
        {deleteAttachResp && (
            <ToastUtility
                topOffset="25%"
                toastDisplay={
                  deleteAttachResp && deleteAttachResp.toastMessage
                      ? "inline"
                      : "none"
                }
                toastVariant={deleteAttachResp?.toastVariant}
                handleClose={() => setDeleteAttachResp({})}
                toastMessage={deleteAttachResp?.toastMessage}
            />
        )}
      </>
  );
}

export default TransactionUtilityBar;